import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import { useBreadcrumbs } from '@renderer/context/BreadcrumbContext'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator
} from '@renderer/components/ui/breadcrumb'

export const BreadcrumbNavigation: React.FC = () => {
  const { breadcrumbs } = useBreadcrumbs()
  const navigate = useNavigate()

  const fullPath = [{ label: 'Workspace', path: '/dashboard' }, ...breadcrumbs]

  return (
    <div className="min-w-0 py-2">
      <Breadcrumb>
        <BreadcrumbList className="gap-0 flex-nowrap">
          {fullPath.map((item, index) => (
            <React.Fragment key={index}>
              <BreadcrumbItem className="min-w-0">
                {index === fullPath.length - 1 ? (
                  <BreadcrumbPage className="text-[#775A00] font-medium text-xs truncate max-w-[160px] sm:max-w-[240px]">
                    {item.label}
                  </BreadcrumbPage>
                ) : (
                  <BreadcrumbLink
                    onClick={() => item.path && navigate(item.path)}
                    className={`${item.path ? 'cursor-pointer hover:text-[#775A00]' : 'cursor-default'} text-[#775A00]/60 text-xs transition-colors truncate max-w-[80px] sm:max-w-[120px]`}
                  >
                    {item.label}
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {index < fullPath.length - 1 && (
                <BreadcrumbSeparator className="text-[#775A00]/40 mx-1.5">
                  <ChevronRight size={14} />
                </BreadcrumbSeparator>
              )}
            </React.Fragment>
          ))}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  )
}
